<template>
  <div id="data-list-list-view">
    <!-- searchSheet -->
    <vx-card class="margin-bottom" title="筛选搜索"  noShadow cardBorder collapseAction>
      <vs-row vs-type="flex">
        <vs-col
          vs-order="1"
          vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="6" vs-xs="12">
            <span>姓名</span>
            <vs-input class="inline-block margin" v-model="searchSheetData.name"/>
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="6" vs-xs="12">
            <span>用户名</span>
            <vs-input class="inline-block margin" v-model="searchSheetData.username"/>
        </vs-col>
        <vs-col
          vs-order="3"
          vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
            <span>注册时间</span>
            <!-- default -->
            <flat-pickr
              v-model="searchSheetData.beginDate"
              class="form-control margin" 
              :config="dateConfig"
              placeholder="开始时间">
            </flat-pickr>
            <!-- default -->
            <flat-pickr
              v-model="searchSheetData.endDate"
              class="form-control margin" 
              :config="dateConfig"
              placeholder="结束时间">
            </flat-pickr>
        </vs-col>
      </vs-row>
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
          <vs-button class="margin" color="primary" type="filled" @click="requestSearch">搜索</vs-button>
          <vs-button class="margin" color="warning" type="border" @click="resetSearch">重置</vs-button>
        </div>
      </div>
    </vx-card>

    <!-- teacher list -->
    <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="list" :hoverFlat="true">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <!-- ADD NEW -->
        <div class="flex">
          <vs-button class="rounded-full mr-4 p-2" color="primary" icon-pack="feather" icon="icon-refresh-cw" @click="init"></vs-button>
          <!-- <vs-button class="rounded-full px-3 py-2" color="warning" type="border" icon-pack="feather" icon="icon-file" @click="exportData">导出数据</vs-button> -->
        </div>
        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mr-4">
          <div class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">
              {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                list.length - currentPage * itemsPerPage > 0
                  ? currentPage * itemsPerPage
                  : list.length
              }}
              of {{ list.length }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 5">
              <span>5</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <template slot="thead">
        <vs-th>序号</vs-th>
        <vs-th sort-key="name">姓名</vs-th>
        <vs-th sort-key="username">用户名</vs-th>
        <vs-th sort-key="create_time">注册时间</vs-th>
        <vs-th sort-key="classroom_num">班级数</vs-th>
        <!-- <vs-th sort-key="classhour_num">上课数</vs-th> -->
        <vs-th sort-key="registered_stu_num">注册学生</vs-th>
        <!-- <vs-th sort-key="actived_stu_num">激活学生</vs-th> -->
        <vs-th>操作</vs-th>
      </template>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name font-medium">{{ indextr + 1 }}</p>
            </vs-td>
            <vs-td>
              <p>{{ tr.name }}</p>
            </vs-td>
            <vs-td>
              <p>{{ tr.username }}</p>
            </vs-td>
            <vs-td>
              <p>{{ tr.create_time }}</p>
            </vs-td>
            <vs-td>
              <p>{{ tr.class_num }}</p>
            </vs-td>
            <!-- <vs-td>
              <p>{{ tr.classhour_num }}</p>
            </vs-td> -->
            <vs-td>
              <p>{{ tr.student_num }}</p>
            </vs-td>
            <!-- <vs-td>
              <p>{{ tr.actived_stu_num }}</p>
            </vs-td> -->
            <vs-td>
              <vs-button class="ml-4" color="warning" size="small" type="filled" @click="showDeletePrompt(tr)">离职</vs-button>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <!-- deleteTeacherPrompt -->
    <vs-prompt
      vs-title="删除教师"
      :vs-buttons-hidden="true"
      :vs-active.sync="deletePrompt"
      @vs-close="closeDeleteTeacherPrompt"
    >
      <div class="con-exemple-prompt">
        <div class="flex flex-col items-center my-4">
          <p>是否确定删除该教师？</p>
          <p class="tips">删除后该教师将无法进入五方学堂</p>
          <div class="mt-3">
            <vs-button color="primary" size="small" type="filled" @click="deleteTeacher">确定</vs-button>
            <vs-button class="margin" color="warning" size="small" type="border" @click="closeDeleteTeacherPrompt">取消</vs-button>
          </div>
        </div>
      </div>
    </vs-prompt>
  </div>
</template>

<script>

import { getTeacherList, removeTeacher } from '@/api/school'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { Mandarin } from 'flatpickr/dist/l10n/zh.js';

export default {
  components: {
    flatPickr
  },
  data() {
    return {
      list: [],
      itemsPerPage: 5,
      isMounted: false,
      deletePrompt: false,
      searchSheetData: {
        name: "",
        username: "",
        beginDate: null,
        endDate: null
      },
      dateConfig: {
        dateFormat: "Y-m-d H:i",	//data变成时间戳
        altFormat: 'Y-m-d H:i',	      //选择时显示的时间
        enableTime:true,			//选择小时分种
        defaultHour: 8,			  //默认8点
        time_24hr: true,			//时间24小时制
        locale: Mandarin	
      },
      currentId: 0,
    }
  },
  created() {},
  mounted() {
    this.isMounted = true;
    this.init();
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
  },
  methods: {
    init() {
      getTeacherList(this.searchSheetData).then(res => {
        if (res.code == 1) {
          this.list = res.data.list
        }
      })
    },
    exportData() {
      this.$vs.notify({
        color: "success",
        text: "导出数据成功",
        title: "提示",
        iconPack: "feather",
        icon: "icon-alert-circle",
      });
    },
    requestSearch() {
      this.init()
    },
    resetSearch() {
      this.searchSheetData = {
        name: "",
        username: "",
        beginDate: null,
        endDate: null
      };
      this.init();
    },
    showDeletePrompt(row) {
      this.currentId = row.id
      this.deletePrompt = true;
    },
    closeDeleteTeacherPrompt() {
      this.deletePrompt = false;
    },
    deleteTeacher() {
      removeTeacher({
        id: this.currentId
      }).then(res => {
        if (res.code == 1) {
          this.$vs.notify({
            color: "success",
            text: "教师离职成功",
            title: "提示",
            iconPack: "feather",
            icon: "icon-alert-circle",
          });
          this.init();
        }
        this.closeDeleteTeacherPrompt();
        
      })
      
    }
  },
}
</script>

<style lang="scss">
#data-list-list-view {
  white-space: nowrap;
}
.margin{
  margin: 0 0 0 1rem;
}
.vs-col{
  margin-bottom: 20px;
}
.vs-con-input-label{
  width: 100%;
}
</style>
